/** Base del API propio sin barra final. */
export function normalizeApiBase(base: string): string {
  return base.replace(/\/$/, '');
}

/** Peticiones al backend del sistema (JWT). Excluye FactuConect y otros hosts externos. */
export function isNuestroApiUrl(url: string, apiBase: string): boolean {
  return url.startsWith(normalizeApiBase(apiBase));
}
